<!-- File: IoT-User-Frontend/src/App.vue -->

<template>
  <div>
    <NavbarHome />
    <Search />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import NavbarHome from '@/components/NavbarHome1.vue';
import Search from '@/components/Search.vue';
import Footer from '@/components/Footer.vue';


export default {
  name: 'app',
  components: {
    NavbarHome,
    Search,
    Footer
  },
}
</script>

<style></style>
